import { render, staticRenderFns } from "./Restore-File.vue?vue&type=template&id=0511d277&scoped=true&"
import script from "./Restore-File.vue?vue&type=script&lang=js&"
export * from "./Restore-File.vue?vue&type=script&lang=js&"
import style0 from "./Restore-File.vue?vue&type=style&index=0&id=0511d277&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511d277",
  null
  
)

export default component.exports